import React, { Component } from 'react';
import LogoIberica from '../images/logo-iberica.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp, faFacebookSquare, faYoutubeSquare, faTwitterSquare, faInstagramSquare, faSoundcloud } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'gatsby';

export default class Footer extends Component {
    render() {
        return(
            <>
            <div className="footer-iberica">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-2" style={{textAlign: "center"}}>
                            <img src={LogoIberica} className="logo-iberica logo-iberica-footer" alt="Logo Ibérica" sizes="(min-width: 80px) 80px" />
                        </div>
                        <div className="col-sm-4">
                            <h3>Contato</h3>
                            <p><FontAwesomeIcon icon={faPhone} /> <a href="tel:1122146260">+55 11 2214-6260</a></p>
                            <a href="https://wa.me/5511983050191" rel="noopener, noreferrer" target="_blank"><p><FontAwesomeIcon icon={faWhatsapp} />  +55 11 98305-0191</p></a>
                            <a href="https://goo.gl/maps/kWmQXgDZLSgfC8mU7" rel="noopener, noreferrer" target="_blank"><p><FontAwesomeIcon icon={faLocationDot} />  Rua Reverendo Izac Silvério, 566 - Jardim Belém - São Paulo/SP - CEP: 03810-030</p></a>
                        </div>
                        <div className="col-sm-2">
                            <h3>Links úteis:</h3>
                            <Link to="/empresa/" className="link-iberica-footer" activeStyle={{borderBottom: "1px solid white", color: "#fff"}}>Empresa</Link><br/>
                            <Link to="/produtos/" className="link-iberica-footer" activeStyle={{borderBottom: "1px solid white", color: "#fff"}}>Produtos</Link><br/>
                            <Link to="/marketing/" className="link-iberica-footer" activeStyle={{borderBottom: "1px solid white", color: "#fff"}}>Marketing</Link><br/>
                            <Link to="/videos-e-podcasts/" className="link-iberica-footer" activeStyle={{borderBottom: "1px solid white", color: "#fff"}}>Vídeos e Podcasts</Link><br/>
                            <Link to="/noticias/" className="link-iberica-footer" activeStyle={{borderBottom: "1px solid white", color: "#fff"}}>Notícias</Link><br/>
                            <Link to="/contato/" className="link-iberica-footer" activeStyle={{borderBottom: "1px solid white", color: "#fff"}}>Contato</Link>
                        </div>
                        <div className="col-sm-4">
                            <h3>Siga-nos nas redes sociais:</h3>
                            <div className="iberica-footer-social">
                                <a href="https://www.facebook.com/ibericacondutoreseletricosltda" rel="noopener, noreferrer" target="_blank"><FontAwesomeIcon icon={faFacebookSquare} /></a>
                                <a href="https://www.instagram.com/ibericacondutores" rel="noopener, noreferrer" target="_blank"><FontAwesomeIcon icon={faInstagramSquare} /></a>
                                <a href="https://www.youtube.com/channel/UC-fUA5lQdWz-XtSR1xxYIFA" rel="noopener, noreferrer" target="_blank"><FontAwesomeIcon icon={faYoutubeSquare} /></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row iberica-footer-text">
                    <p>Ibérica Condutores Elétricos LTDA. • CNPJ nº 00.384.033/0001-82 • <Link to="/politica-de-privacidade/">Política de Privacidade</Link></p>
                </div>
            </div>
            </>
        )
    }
}